<template>
  <v-container class="pa-0">
    <v-card
      elevation="2"
    >
      <v-form
        v-if="!isSearch"
        ref="userInfo"
        v-model="userInfo"
        lazy-validation
      >
        <v-card-title class="font-weight-bold justify-center">
          聯絡資訊
        </v-card-title>
        <v-text-field
          class="ma-4"
          dense
          prepend-icon="mdi-account"
          placeholder="請輸入姓名"
          hide-details="auto"
          :rules="commonRules.requiredRule"
        />
        <v-text-field
          class="ma-4"
          dense
          prepend-icon="mdi-cellphone"
          hide-details="auto"
          placeholder="請輸入手機號碼"
          maxlength="10"
          :rules="commonRules.requiredRule.concat(formatRules.phoneRules)"
        />
      </v-form>
      <v-card-title class="font-weight-bold justify-center">
        訂房列表
      </v-card-title>
      <v-card-title
        v-if="isSearch"
        class="justify-center"
      >
        入住日期 ~ 退房日期
        <span>

          {{ orderInfoObj.dateRange.join(' ~ ') }}
        </span>
      </v-card-title>

      <v-divider />
      <v-data-table
        :headers="orderInfoHeader"
        :items="orderRoomList"
        :mobile-breakpoint="0"
        hide-default-footer
      >
        <template
          v-if="!isSearch"
          v-slot:item.total="{ item }"
        >
          {{ `${item.price*item.orderQuantity}` }}
        </template>
        <template
          v-if="!isSearch"
          v-slot:item.action="{ item }"
        >
          <v-icon
            color="red"
            @click="$emit('reduceOrderQuantity',item.id)"
          >
            mdi-minus-box
          </v-icon>
        </template>
      </v-data-table>
      <v-divider />

      <v-card-actions class="justify-center">
        <p class="pt-2 mb-0 font-weight-bold totalPrice">
          {{ `共${orderRoomList.length}筆，總金額$${isSearch?orderInfoObj.totalPrice: totalPrice}` }}
        </p>
      </v-card-actions>
      <v-card-actions
        class="justify-center"
      >
        <slot name="dialogActions">
          <v-btn
            width="100"
            color="primary"
            class="font-weight-bold mt-2"
            :disabled="!userInfo"
            @click="submit"
          >
            送出
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
    <!-- <h3 class="text-center"></h3> -->
    <!-- <v-divider></v-divider> -->
  </v-container>
</template>

<script>
import { commonRules, formatRules } from '../module/pages/mixins/CommonRules'

export default {
  mixins: [commonRules, formatRules],
  props: {
    orderRoomList: Array,
    isSearch: Boolean,
    orderInfoObj: Object
  },
  data () {
    return {
      userInfo: false,
      orderInfoHeader: [
        { value: 'name', text: '名稱' },
        { value: 'orderQuantity', text: '數量' },
        { value: 'total', text: '小計' },
        { value: 'action', text: '', sortable: false }
      ]
    }
  },
  computed: {
    totalPrice () {
      let totalPrice = 0
      this.orderRoomList.forEach(element => {
        // debugger
        totalPrice += element.price * element.orderQuantity
      })
      return totalPrice
    }
  },
  mounted () {
    console.log(this.$route.params.isUser)
  },
  methods: {
    submit () {
      if (this.$refs.userInfo.validate()) {
        this.$root.$confirm.open('送出', '確定要送出資料?', {
          type: 'confirm'
        })
      }
    }
  }
}
</script>

<style scoped>
.totalPrice{
  display: block
}
</style>
